const coinbaseOriginalDeeplink = (url: string) => `cbwallet://dapp?url=${encodeURIComponent(url)}`

export default coinbaseOriginalDeeplink